"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _mysql = /*#__PURE__*/ _interop_require_default(require("~/db/functionMappings/mysql"));
const _pg = /*#__PURE__*/ _interop_require_default(require("~/db/functionMappings/pg"));
const _sqlite = /*#__PURE__*/ _interop_require_default(require("~/db/functionMappings/sqlite"));
const _databricks = /*#__PURE__*/ _interop_require_default(require("~/db/functionMappings/databricks"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const mapFunctionName = async (args)=>{
    const name = args.pt.callee.name.toUpperCase();
    let val;
    switch(args.knex.clientType()){
        case 'mysql':
        case 'mysql2':
        case 'maridb':
            val = _mysql.default[name] || name;
            break;
        case 'pg':
        case 'postgre':
            val = _pg.default[name] || name;
            break;
        case 'sqlite':
        case 'sqlite3':
            val = _sqlite.default[name] || name;
            break;
        case 'databricks':
            val = _databricks.default[name] || name;
            break;
    }
    if (typeof val === 'function') {
        return val(args);
    } else if (typeof val === 'string') {
        args.pt.callee.name = val;
    }
};
const _default = mapFunctionName;
